import cabri from "../app/cabri-app";

class GeomRelation {

    constructor (objectId) {
        this.objectId = objectId;
    }

    dispose () {

    }

    readId () {
        if (this.objectId !== 0) {
            this.setId(cabri.emsc.getId(this.objectId));
        }
    }

    setId (id) {
        this.idString = id;
    }

    getId () {
        return this.idString;
    }

}

export {GeomRelation};